export const getForecastMonths15 = (): { label: string; dateString: string }[] => {
  const arr: { label: string; dateString: string }[] = [];
  const dt = new Date();
  const startMonth = dt.getMonth();
  const startYear = dt.getFullYear();
  const monthShortHand = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  for (let i = 0; i < 15; i++) {
    const month = (startMonth + i + 1) % 12;
    const year = startYear + Math.floor((startMonth + i + 1) / 12);
    arr.push({
      label: `${monthShortHand[month]}-${year}`,
      dateString: `${year}-${month >= 9 ? month + 1 : `0${month + 1}`}-01`,
    });
  }
  return arr;
};

export const getPriorMonth = (): { label: string; dateString: string } => {
  const dt = new Date();
  const month = dt.getMonth();
  const year = dt.getFullYear();
  const monthShortHand = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return { label: `${monthShortHand[month]}-${year}`, dateString: `${year}-${month >= 9 ? month + 1 : `0${month + 1}`}-01` };
};

export interface SalesPlanBulkEditMockRow {
  GFC: number;
  Concept: string;
  COT: string;
  SellingCategory: string;
  SupplierName: string;
  ContractType: 'MAS' | 'NC';
  Ramping: boolean;
  MoleculeAndDosageForm: string;
  StrategyCode: string;
  priorMonthValue: number;
  priorCycleForecast: number[];
  forecast_data: {
    ForecastPeriod: string;
    MarketForecast: number;
    AdjMarketForecast: number;
    TMS: string;
    MSPlan: string;
    EUSalesPlan: number;
  }[];
}

// Helper to build forecast data
const buildForecastData = (baseEU: number, variance: number = 0.08) => {
  const months = getForecastMonths15();
  return months.map((m, i) => {
    const seasonalFactor = 1 + Math.sin((i / 15) * Math.PI * 2) * variance;
    const euSalesPlan = Math.round(baseEU * seasonalFactor);
    const marketForecast = Math.round(euSalesPlan * 1.8);
    const adjMarketForecast = Math.round(marketForecast * (0.95 + Math.sin(i * 0.5) * 0.05));
    const tmsVal = (15 + Math.sin(i * 0.3) * 5).toFixed(1) + '%';
    const msPlanVal = (12 + Math.sin(i * 0.4) * 3).toFixed(1) + '%';
    return {
      ForecastPeriod: m.dateString,
      MarketForecast: marketForecast,
      AdjMarketForecast: adjMarketForecast,
      TMS: tmsVal,
      MSPlan: msPlanVal,
      EUSalesPlan: euSalesPlan,
    };
  });
};

const buildPriorCycleForecast = (baseEU: number, variance: number = 0.08): number[] => {
  return Array.from({ length: 15 }, (_, i) => {
    const seasonalFactor = 1 + Math.sin((i / 15) * Math.PI * 2) * variance;
    const reduction = 0.92 + Math.sin(i * 0.7) * 0.03;
    return Math.round(baseEU * seasonalFactor * reduction);
  });
};

export const mockSalesPlanBulkEditData: SalesPlanBulkEditMockRow[] = [
  {
    GFC: 10234,
    Concept: 'Lisinopril 10mg Tablet',
    COT: 'CMOP',
    SellingCategory: 'Direct',
    SupplierName: 'Teva',
    ContractType: 'MAS',
    Ramping: false,
    MoleculeAndDosageForm: 'Lisinopril / Tablet',
    StrategyCode: 'A',
    priorMonthValue: 24500,
    priorCycleForecast: buildPriorCycleForecast(24500),
    forecast_data: buildForecastData(25000),
  },
  {
    GFC: 10235,
    Concept: 'Lisinopril 10mg Tablet',
    COT: 'VA Facility',
    SellingCategory: 'Indirect',
    SupplierName: 'Teva',
    ContractType: 'MAS',
    Ramping: false,
    MoleculeAndDosageForm: 'Lisinopril / Tablet',
    StrategyCode: 'A',
    priorMonthValue: 18200,
    priorCycleForecast: buildPriorCycleForecast(18200),
    forecast_data: buildForecastData(18500),
  },
  {
    GFC: 20471,
    Concept: 'Amlodipine 5mg Tablet',
    COT: 'CMOP',
    SellingCategory: 'Direct',
    SupplierName: 'Mylan',
    ContractType: 'NC',
    Ramping: true,
    MoleculeAndDosageForm: 'Amlodipine / Tablet',
    StrategyCode: 'B',
    priorMonthValue: 32100,
    priorCycleForecast: buildPriorCycleForecast(32100),
    forecast_data: buildForecastData(33000),
  },
  {
    GFC: 20472,
    Concept: 'Amlodipine 5mg Tablet',
    COT: 'TMOP',
    SellingCategory: 'Direct',
    SupplierName: 'Mylan',
    ContractType: 'MAS',
    Ramping: false,
    MoleculeAndDosageForm: 'Amlodipine / Tablet',
    StrategyCode: 'B',
    priorMonthValue: 14800,
    priorCycleForecast: buildPriorCycleForecast(14800),
    forecast_data: buildForecastData(15200),
  },
  {
    GFC: 30589,
    Concept: 'Metformin 500mg Tablet',
    COT: 'VA Facility',
    SellingCategory: 'Indirect',
    SupplierName: 'Aurobindo',
    ContractType: 'MAS',
    Ramping: false,
    MoleculeAndDosageForm: 'Metformin HCl / Tablet',
    StrategyCode: 'A',
    priorMonthValue: 42000,
    priorCycleForecast: buildPriorCycleForecast(42000),
    forecast_data: buildForecastData(43500),
  },
  {
    GFC: 30590,
    Concept: 'Metformin 500mg Tablet',
    COT: 'MTF',
    SellingCategory: 'Direct',
    SupplierName: 'Aurobindo',
    ContractType: 'NC',
    Ramping: true,
    MoleculeAndDosageForm: 'Metformin HCl / Tablet',
    StrategyCode: 'C',
    priorMonthValue: 8900,
    priorCycleForecast: buildPriorCycleForecast(8900),
    forecast_data: buildForecastData(9200),
  },
  {
    GFC: 40612,
    Concept: 'Omeprazole 20mg Capsule',
    COT: 'CMOP',
    SellingCategory: 'Direct',
    SupplierName: "Dr. Reddy's",
    ContractType: 'MAS',
    Ramping: false,
    MoleculeAndDosageForm: 'Omeprazole / Capsule',
    StrategyCode: 'B',
    priorMonthValue: 27800,
    priorCycleForecast: buildPriorCycleForecast(27800),
    forecast_data: buildForecastData(28500),
  },
  {
    GFC: 40613,
    Concept: 'Omeprazole 20mg Capsule',
    COT: 'TMOP',
    SellingCategory: 'Indirect',
    SupplierName: "Dr. Reddy's",
    ContractType: 'MAS',
    Ramping: false,
    MoleculeAndDosageForm: 'Omeprazole / Capsule',
    StrategyCode: 'B',
    priorMonthValue: 19500,
    priorCycleForecast: buildPriorCycleForecast(19500),
    forecast_data: buildForecastData(20000),
  },
  {
    GFC: 50744,
    Concept: 'Atorvastatin 40mg Tablet',
    COT: 'VA Facility',
    SellingCategory: 'Direct',
    SupplierName: 'Sun Pharma',
    ContractType: 'NC',
    Ramping: true,
    MoleculeAndDosageForm: 'Atorvastatin Calcium / Tablet',
    StrategyCode: 'C',
    priorMonthValue: 36400,
    priorCycleForecast: buildPriorCycleForecast(36400),
    forecast_data: buildForecastData(37500),
  },
  {
    GFC: 50745,
    Concept: 'Atorvastatin 40mg Tablet',
    COT: 'CMOP',
    SellingCategory: 'Direct',
    SupplierName: 'Sun Pharma',
    ContractType: 'MAS',
    Ramping: false,
    MoleculeAndDosageForm: 'Atorvastatin Calcium / Tablet',
    StrategyCode: 'A',
    priorMonthValue: 21300,
    priorCycleForecast: buildPriorCycleForecast(21300),
    forecast_data: buildForecastData(22000),
  },
  {
    GFC: 60821,
    Concept: 'Losartan 50mg Tablet',
    COT: 'MTF',
    SellingCategory: 'Indirect',
    SupplierName: 'Lupin',
    ContractType: 'MAS',
    Ramping: false,
    MoleculeAndDosageForm: 'Losartan Potassium / Tablet',
    StrategyCode: 'D',
    priorMonthValue: 15600,
    priorCycleForecast: buildPriorCycleForecast(15600),
    forecast_data: buildForecastData(16000),
  },
  {
    GFC: 60822,
    Concept: 'Losartan 50mg Tablet',
    COT: 'CMOP',
    SellingCategory: 'Direct',
    SupplierName: 'Lupin',
    ContractType: 'NC',
    Ramping: true,
    MoleculeAndDosageForm: 'Losartan Potassium / Tablet',
    StrategyCode: 'D',
    priorMonthValue: 29100,
    priorCycleForecast: buildPriorCycleForecast(29100),
    forecast_data: buildForecastData(30000),
  },
  {
    GFC: 70933,
    Concept: 'Gabapentin 300mg Capsule',
    COT: 'TMOP',
    SellingCategory: 'Direct',
    SupplierName: 'Teva',
    ContractType: 'MAS',
    Ramping: false,
    MoleculeAndDosageForm: 'Gabapentin / Capsule',
    StrategyCode: 'A',
    priorMonthValue: 38700,
    priorCycleForecast: buildPriorCycleForecast(38700),
    forecast_data: buildForecastData(39500),
  },
  {
    GFC: 70934,
    Concept: 'Gabapentin 300mg Capsule',
    COT: 'VA Facility',
    SellingCategory: 'Indirect',
    SupplierName: 'Aurobindo',
    ContractType: 'NC',
    Ramping: false,
    MoleculeAndDosageForm: 'Gabapentin / Capsule',
    StrategyCode: 'C',
    priorMonthValue: 11200,
    priorCycleForecast: buildPriorCycleForecast(11200),
    forecast_data: buildForecastData(11800),
  },
  {
    GFC: 81045,
    Concept: 'Sertraline 100mg Tablet',
    COT: 'CMOP',
    SellingCategory: 'Direct',
    SupplierName: 'Mylan',
    ContractType: 'MAS',
    Ramping: true,
    MoleculeAndDosageForm: 'Sertraline HCl / Tablet',
    StrategyCode: 'B',
    priorMonthValue: 22400,
    priorCycleForecast: buildPriorCycleForecast(22400),
    forecast_data: buildForecastData(23000),
  },
  {
    GFC: 81046,
    Concept: 'Sertraline 100mg Tablet',
    COT: 'MTF',
    SellingCategory: 'Direct',
    SupplierName: "Dr. Reddy's",
    ContractType: 'MAS',
    Ramping: false,
    MoleculeAndDosageForm: 'Sertraline HCl / Tablet',
    StrategyCode: 'B',
    priorMonthValue: 9800,
    priorCycleForecast: buildPriorCycleForecast(9800),
    forecast_data: buildForecastData(10200),
  },
  {
    GFC: 91157,
    Concept: 'Tamsulosin 0.4mg Capsule',
    COT: 'VA Facility',
    SellingCategory: 'Indirect',
    SupplierName: 'Sun Pharma',
    ContractType: 'NC',
    Ramping: false,
    MoleculeAndDosageForm: 'Tamsulosin HCl / Capsule',
    StrategyCode: 'D',
    priorMonthValue: 17400,
    priorCycleForecast: buildPriorCycleForecast(17400),
    forecast_data: buildForecastData(18000),
  },
  {
    GFC: 91158,
    Concept: 'Tamsulosin 0.4mg Capsule',
    COT: 'TMOP',
    SellingCategory: 'Direct',
    SupplierName: 'Lupin',
    ContractType: 'MAS',
    Ramping: true,
    MoleculeAndDosageForm: 'Tamsulosin HCl / Capsule',
    StrategyCode: 'A',
    priorMonthValue: 26300,
    priorCycleForecast: buildPriorCycleForecast(26300),
    forecast_data: buildForecastData(27000),
  },
  {
    GFC: 12269,
    Concept: 'Montelukast 10mg Tablet',
    COT: 'CMOP',
    SellingCategory: 'Direct',
    SupplierName: 'Teva',
    ContractType: 'MAS',
    Ramping: false,
    MoleculeAndDosageForm: 'Montelukast Sodium / Tablet',
    StrategyCode: 'C',
    priorMonthValue: 31500,
    priorCycleForecast: buildPriorCycleForecast(31500),
    forecast_data: buildForecastData(32500),
  },
  {
    GFC: 12270,
    Concept: 'Montelukast 10mg Tablet',
    COT: 'MTF',
    SellingCategory: 'Indirect',
    SupplierName: 'Aurobindo',
    ContractType: 'NC',
    Ramping: true,
    MoleculeAndDosageForm: 'Montelukast Sodium / Tablet',
    StrategyCode: 'C',
    priorMonthValue: 7600,
    priorCycleForecast: buildPriorCycleForecast(7600),
    forecast_data: buildForecastData(8000),
  },
];

// Filter option constants
export const SUPPLIER_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Teva', value: 'Teva' },
  { label: 'Mylan', value: 'Mylan' },
  { label: 'Aurobindo', value: 'Aurobindo' },
  { label: "Dr. Reddy's", value: "Dr. Reddy's" },
  { label: 'Sun Pharma', value: 'Sun Pharma' },
  { label: 'Lupin', value: 'Lupin' },
];

export const CONTRACT_TYPE_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'MAS', value: 'MAS' },
  { label: 'NC', value: 'NC' },
];

export const COT_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'CMOP', value: 'CMOP' },
  { label: 'VA Facility', value: 'VA Facility' },
  { label: 'TMOP', value: 'TMOP' },
  { label: 'MTF', value: 'MTF' },
];

export const SELLING_CATEGORY_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Direct', value: 'Direct' },
  { label: 'Indirect', value: 'Indirect' },
];

export const RAMPING_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];

export const STRATEGY_CODE_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'A', value: 'A' },
  { label: 'B', value: 'B' },
  { label: 'C', value: 'C' },
  { label: 'D', value: 'D' },
];
